<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement">
				<img src="@/assets/contact_slices/Group 1162@2x.png" style="width: 13px; height: 16px" />
				<div class="cement">回收流程</div>
			</div>
			<div class="border-top"></div>
			<div>
				<div class="flex-more">
					<div>
						<img src="@/assets/Home_slices1/Group 951@2x.png" class="images" />
					</div>
					<div class="hot-group1">
						<div class="hot-slices"></div>
						<div class="title-tots">完成实名认证</div>
					</div>
					<div>
						<img src="@/assets/Home_slices1/Group 951@2x(1).png" class="images" />
					</div>
					<div class="hot-group1">
						<div class="hot-slices"></div>
						<div class="title-tots">等待平台认证</div>
					</div>
					<div>
						<img src="@/assets/Home_slices1/Group 951@2x(2).png" class="images" />
					</div>
					<div class="hot-group1">
						<div class="hot-slices"></div>
						<div class="title-tots">相应资金到账</div>
					</div>
					<div>
						<img src="@/assets/Home_slices1/Group 1214@2x.png" class="images" />
					</div>
					<div class="hot-group1">
						<div class="hot-slices"></div>
						<div class="title-tots">绑定提现账号</div>
					</div>
					<div>
						<img src="@/assets/Home_slices1/Group 1215@2x.png" class="images" />
					</div>
					<div class="hot-group1">
						<div class="hot-slices"></div>
						<div class="title-tots">银行或支付宝</div>
					</div>
					<div>
						<img src="@/assets/Home_slices1/Group 951@2x(3).png" class="images" />
					</div>
				</div>
			</div>
			<div class="assets-vector">
				<div class="asset-paingd">
					<img src="@/assets/contact_slices/Vector@2x (91).png" style="height: 18px; height: 18px;"/>
					<div class="title-asset">帐号请绑定手机号码，以便我们处理您提交的卡出现问题时可以及时和您联系；</div>
				</div>
			</div>
			<div class="assets-vector" style="margin-top: 17px;">
				<div class="asset-paingd">
					<img src="@/assets/contact_slices/Vector@2x (91).png" style="height: 18px; height: 18px;"/>
					<div class="title-asset">请务必按照格式提交正确的卡号卡密，以免浪费您的时间并给您造成不必要的困扰。</div>
				</div>
			</div>
			<div style="height: 20px;"></div>
		</div>
	</div>
</template>

<script></script>

<style lang="scss" scoped>
.content-assets {
	padding: 20px 21px;
}

.content {
	width: 85%;
	background-color: #fff;
	margin-left: 20px;
	margin-left: auto;
}

.flex-cement {
	position: relative;
	display: flex;
	align-items: center;

	.cement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		margin-left: 8px;
		font-style: normal;
		text-transform: none;
	}
}

.flex-contact-slices {
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
}

.assets-return {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 4px;
	margin-top: 2px;
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
	margin-top: 10px;
}
.title-slice {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.flex-more {
	display: flex;
	justify-content: space-between;
	margin-left: 44px;
	margin-top: 30px;
}
.more-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-style: normal;
	margin-top: 6px;
	text-transform: none;
}
.hot-group {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
	padding-bottom: 7px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: -10px;
}
.hot-group1{
	margin-top: 80px;
}
.title-tots{
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
}
.hot-slices {
	margin: auto;
	width: 50px;
	height: 0px;
	border-top: 2px solid #eeeeee;
	padding-top: 10px;
}

.images {
	width: 85%;
	height: auto;
}

.assets-vector{
	width: 94%;
	background: #FFF5F5;
	border-radius: 7px;
	margin: auto;
	margin-top: 70px;
}
.asset-paingd{
	padding: 16px 12px;
	display: flex;
	align-items: center;
}

.title-asset{
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #DB8A8A;
	font-style: normal;
	text-transform: none;
	margin-left: 8px;
}
</style>
